// Wire-shape responses for /annotations endpoints.
import { z } from 'zod';
import { Annotation } from './annotation.js';
export const AnnotationResponse = z.object({ annotation: Annotation });
export const AnnotationListResponse = z.object({
    annotations: z.array(Annotation),
    total: z.number().int().nonnegative().optional(),
    limit: z.number().int().positive().optional(),
    offset: z.number().int().nonnegative().optional(),
});
export const AnnotationCapabilitiesResponse = z.object({
    trackedChangesEnabled: z.boolean(),
    privateScopeEnabled: z.boolean(),
    groupScopeEnabled: z.boolean(),
});
export const OkResponse = z.object({ ok: z.literal(true) });
//# sourceMappingURL=responses.js.map